import { createAsyncThunk } from '@reduxjs/toolkit';

import type { IViewedVideosInTimespan } from '@/Module/Workspace/Model/DataModel';
import { WorkspaceService } from '@/Module/Workspace/Service';

export const getViewedInWeekAction = createAsyncThunk<IViewedVideosInTimespan[]>(
  'workspace/getViewedInWeekAction',
  async (_, { signal }) => {
    return WorkspaceService.getSeenInWeek(signal).then(({ data: { data } }) => data);
  },
);
